import { createTypes } from "../../utils/helpers";

const EQUIPMENTS_CLEAR_ENTITIES = 'EQUIPMENTS_CLEAR_ENTITIES';
const EQUIPMENTS_CLEAR_ENTITY = 'EQUIPMENTS_CLEAR_ENTITY';
const EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES = 'EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES';
const EQUIPMENTS_SET_ROWS_PER_PAGE = 'EQUIPMENTS_SET_ROWS_PER_PAGE';
const EQUIPMENTS_SET_PAGE = 'EQUIPMENTS_SET_PAGE';
const EQUIPMENTS_SET_SEARCH_OBJECT = 'EQUIPMENTS_SET_SEARCH_OBJECT';
const EQUIPMENTS_CLEAR_PAGINATION_INFO =
    'EQUIPMENTS_CLEAR_PAGINATION_INFO';
const EQUIPMENTS_SET_REGIONS = 'EQUIPMENTS_SET_REGIONS';
const EQUIPMENTS_SET_COUNTRIES = 'EQUIPMENTS_SET_COUNTRIES';
const EQUIPMENTS_SET_EQUIPMENT_TO_EDIT =
    'EQUIPMENTS_SET_EQUIPMENT_TO_EDIT';
const CLEAR_EQUIPMENT_HOLDING_PROFILE =
    'CLEAR_EQUIPMENT_HOLDING_PROFILE';
const EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS: any = createTypes(
    'EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS',
);
const EQUIPMENTS_EDIT_EQUIPMENT: any = createTypes('EQUIPMENTS_EDIT_EQUIPMENT');
const EQUIPMENTS_FETCH_EQUIPMENTS: any = createTypes(
    'EQUIPMENTS_FETCH_EQUIPMENTS',
);
const EQUIPMENTS_FETCH_EQUIPMENTS_PIECES: any = createTypes(
    'EQUIPMENTS_FETCH_EQUIPMENTS_PIECES',
);

const EQUIPMENTS_FETCH_EQUIPMENT: any = createTypes(
    'EQUIPMENTS_FETCH_EQUIPMENT',
);
const EQUIPMENTS_FETCH_CATEGORIES: any = createTypes(
    'EQUIPMENTS_FETCH_CATEGORIES',
);
const EQUIPMENTS_FETCH_MODELS: any = createTypes('EQUIPMENTS_FETCH_MODELS');
const EQUIPMENTS_FETCH_SUPPLIERS: any = createTypes(
    'EQUIPMENTS_FETCH_SUPPLIERS',
);
const EQUIPMENTS_CREATE_EQUIPMENT: any = createTypes(
    'EQUIPMENTS_CREATE_EQUIPMENT',
);
const EQUIPMENTS_FETCH_HOLDING_PROFILES: any = createTypes(
    'EQUIPMENTS_FETCH_HOLDING_PROFILES',
);
const EQUIPMENTS_TRANSLATIONS: any = createTypes('EQUIPMENTS_TRANSLATIONS');
const EQUIPMENTS_FETCH_HOLDING_PROFILE: any = createTypes(
    'EQUIPMENTS_FETCH_HOLDING_PROFILE',
);
const EQUIPMENTS_TRANSLATIONS_UPDATE: any = createTypes(
    'EQUIPMENTS_TRANSLATIONS_UPDATE',
);
const EQUIPMENT_SERIAL_NUMBERS_FETCH: any = createTypes(
    'EQUIPMENT_SERIAL_NUMBERS_FETCH',
);
const EQUIPMENT_PRODUCT_PROFILES_FETCH: any = createTypes(
    'EQUIPMENT_PRODUCT_PROFILES_FETCH',
);
const DELETE_HOLDING_PROFILES: any = createTypes('DELETE_HOLDING_PROFILES');
export {
    EQUIPMENTS_FETCH_EQUIPMENTS,
    EQUIPMENTS_FETCH_EQUIPMENTS_PIECES,
    EQUIPMENTS_FETCH_EQUIPMENT,
    EQUIPMENTS_FETCH_CATEGORIES,
    EQUIPMENTS_FETCH_MODELS,
    EQUIPMENTS_FETCH_SUPPLIERS,
    EQUIPMENTS_CREATE_EQUIPMENT,
    EQUIPMENTS_EDIT_EQUIPMENT,
    EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS,
    EQUIPMENTS_FETCH_HOLDING_PROFILES,
    EQUIPMENTS_FETCH_HOLDING_PROFILE,
    EQUIPMENTS_TRANSLATIONS,
    EQUIPMENTS_TRANSLATIONS_UPDATE,
    EQUIPMENT_SERIAL_NUMBERS_FETCH,
    EQUIPMENT_PRODUCT_PROFILES_FETCH,
    EQUIPMENTS_CLEAR_ENTITIES,
    EQUIPMENTS_CLEAR_ENTITY,
    EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES,
    EQUIPMENTS_SET_ROWS_PER_PAGE,
    EQUIPMENTS_SET_PAGE,
    EQUIPMENTS_SET_SEARCH_OBJECT,
    EQUIPMENTS_CLEAR_PAGINATION_INFO,
    EQUIPMENTS_SET_REGIONS,
    EQUIPMENTS_SET_COUNTRIES,
    EQUIPMENTS_SET_EQUIPMENT_TO_EDIT,
    DELETE_HOLDING_PROFILES,
    CLEAR_EQUIPMENT_HOLDING_PROFILE,
};
